<template>
  <div>
    <p>{{ adSet.name }}</p>

    <deposits-campaign-adset-preview-summary-row
      name="Product Type"
      :items="adSet.loan_purposes"
    ></deposits-campaign-adset-preview-summary-row>

    <deposits-campaign-adset-preview-summary-row
      v-if="isCertifcatesOfDeposit"
      name="CD Terms"
      :items="cdTerms"
    ></deposits-campaign-adset-preview-summary-row>

    <deposits-campaign-adset-preview-summary-row
      name="States Included"
      :items="states"
      label="id"
    ></deposits-campaign-adset-preview-summary-row>
  </div>
</template>

<script type="text/babel">
  export default {
    props: {
      adSet: {
        type: Object
      },
      dimensions: {
        type: Object
      },
      isNationalLoanPurpose: Boolean,
    },
    computed: {
      isCertifcatesOfDeposit () {
        return (this.adSet.loan_purposes.length == 1) && (this.adSet.loan_purposes[0].id == 'certificate of deposit');
      },
      allStatesSelected () {
        return this.adSet.locations.length >= 50;
      },
      allCdTermsSelected () {
        return this.adSet.terms_cd_months.length == this.dimensions.terms_cd.length || this.adSet.terms_cd_months.length == 0;
      },
      cdTerms () {
        if (this.allCdTermsSelected) {
          return [{ label: 'All Terms ' }];
        }

        const that = this;

        return _.sortBy(this.adSet.terms_cd_months.map(function (id) {
          return _.find(that.dimensions.terms_cd, { id });
        }), 'id');
      },
      loanSizes () {
        return _.sortBy(this.adSet.loan_sizes, ['label']);
      },
      states () {
        if (this.isNationalLoanPurpose) {
            return [{ id: 'National'}];
        }

        if (this.allStatesSelected) {
          return [{ id: 'All States ' }];
        }

        return _.orderBy(this.adSet.locations, [location => location.id.toLowerCase()], ['asc']);
      }
    }
  };
</script>
